import { Flex, Box } from '@cad-arc';
import { EventSearchOptions } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { FormInput } from '../forms/integrated-form-controls/form-input';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { EventSearchFormType } from './types';
import { FormSection } from '../search-windows/form-section';
import { INPUT_WIDTH_SM } from '../search-windows/constants';

export function EventSearchFormAttachmentsSection({
    form,
    options,
}: Readonly<{
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
}>) {
    return (
        <FormSection title="Attachments" testId="event-search-attachments-section">
            <Flex flex={1} flexFlow="wrap" gap="1rem">
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="hasAttachments"
                        label="Has attachment(s)"
                        control={form.control}
                        options={options.hasAttachmentsOptions}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormInput
                        name="attachmentFileName"
                        label="File name"
                        control={form.control}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="attachmentCategories"
                        label="File types"
                        control={form.control}
                        options={options.attachmentCategoryOptions}
                        isMultiple
                        truncateSelectedCount={2}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormInput
                        name="attachmentDescription"
                        label="File description"
                        control={form.control}
                    />
                </Box>
            </Flex>
        </FormSection>
    );
}
